import { render, staticRenderFns } from "./CorrectTranscriptModal.vue?vue&type=template&id=4af8bb7a&scoped=true&"
import script from "./CorrectTranscriptModal.vue?vue&type=script&lang=js&"
export * from "./CorrectTranscriptModal.vue?vue&type=script&lang=js&"
import style0 from "./CorrectTranscriptModal.vue?vue&type=style&index=0&id=4af8bb7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af8bb7a",
  null
  
)

export default component.exports